module.exports = __webpack_public_path__ + "img/sex-for-aaben-3.da8303ad.png";